import { useCallback } from 'react';
import { store } from 'Utilities/store';
import { getConnectionsService } from 'Services/libre_api';
const useLibreConnection = () => {
    const getConnections = useCallback(async () => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        const connections = await getConnectionsService(user.id, osType, osVersion, app, appVersion);
        return connections;
    }, []);
    return { getConnections };
};
export default useLibreConnection;
